import { pick } from 'ramda';

export default pick(['for', 'form']);
